import React from "react";
import { withRouter } from "react-router-dom";
import ErrorPage from "./ErrorPage";

class ErrorBoundary extends React.Component {
  state = { hasError: false, error: null };

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo){
    console.error("Error caught by boundary", error, errorInfo)
  }

  handleRefresh = () => {
    window.location.reload();
  };

  resetAndGoHome = () => {
    this.setState({ hasError: false }, () => {
      this.props.history.push("/");
    });
  };

  render() {
    if (this.state.hasError) {
      return (
        <ErrorPage
          onHandleReset={this.resetAndGoHome}
          error={this.state.error}
          handleRefresh={this.handleRefresh}
        />
      );
    }

    return this.props.children;
  }
}

export default withRouter(ErrorBoundary);
